import { connect } from 'react-redux';
//
import DealDetailPage from 'pages/deal-detail/deal-detail-page';
import { IStoreState } from 'store';
import { editDealCancel, editDealStart } from 'store/deal-edit/actions';
import { setPageTitle } from 'store/general/actions';
import { getDealEvaluation } from 'store/deal-evaluation/actions';
import { getDeals } from 'store/deals/actions';

const mapStateToProps = ({ deals, fieldOptions }: IStoreState) => {
  const { products, productLines, regions } = fieldOptions;
  return {
    deals,
    regions,
    products,
    productLines,
  };
};

const mapDispatchToProps = {
  editDealCancel,
  editDealStart,
  getDealEvaluation,
  getDeals,
  setPageTitle,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealDetailPage);
